import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';

import { canAccessReports, REPORTS_ACCESS_PERMISSIONS } from '@/lib/module-access';
import { hasAnyPermission, useCurrentMembership } from '@/lib/permissions';
import { useChurchStore } from '@/stores/church-store';
import { cn } from '@/utils/cn';

const LINKS = [
  { to: '/reports', end: true, key: 'nav.readyMade' },
  {
    to: '/reports/custom',
    end: false,
    key: 'nav.custom',
    requiresCustomReports: true,
  },
  { to: '/reports/favorites', end: true, key: 'nav.favorites' },
  { to: '/reports/combined', end: true, key: 'nav.combined' },
] as const;

export const ReportsSubnav = () => {
  const { t } = useTranslation('reports');
  const membership = useCurrentMembership();
  const allowsFeature = useChurchStore((state) => state.allowsFeature);

  if (!canAccessReports(membership)) return null;

  const visibleLinks = LINKS.filter((link) => {
    if ('requiresCustomReports' in link && link.requiresCustomReports) {
      return allowsFeature('custom_reports') && hasAnyPermission(membership, REPORTS_ACCESS_PERMISSIONS);
    }
    return true;
  });

  return (
    <nav className="mb-6 flex flex-wrap gap-2" aria-label={t('title')}>
      {visibleLinks.map((link) => (
        <NavLink
          key={link.to}
          to={link.to}
          end={link.end}
          className={({ isActive }) =>
            cn(
              'rounded-md px-3 py-1.5 text-body-sm',
              isActive ? 'bg-brand/10 text-brand' : 'text-fg-secondary hover:bg-surface-sunken',
            )
          }
        >
          {t(link.key)}
        </NavLink>
      ))}
    </nav>
  );
};
